// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NonIdealState_wrapper__SwDEZ","icon":"NonIdealState_icon__zfFp7","title":"NonIdealState_title__1uXUo","content":"NonIdealState_content__207iO"};